import { gql } from '@apollo/client';

export const REGISTER_RFID = gql`
  mutation RegisterRfid($input: RegisterRfidInput!) {
    registerRfid(input: $input)
  }
`;
